/** Date helpers for the kiosk clock-in modal. The backend sends planning dates as ISO date-times
 *  at local midnight (no `Z`); we treat them as plain calendar dates to avoid timezone day-shifts. */

/** ISO date-time (e.g. "2026-06-24T00:00:00") → "YYYY-MM-DD". */
export const isoToYmd = (iso: string): string => iso.slice(0, 10);

/** "YYYY-MM-DD" → a local Date at midnight (no UTC shift). */
export const ymdToLocalDate = (ymd: string): Date => {
  const [y, m, d] = ymd.split('-').map(Number);
  return new Date(y || 1970, (m || 1) - 1, d || 1);
};

/** Local Date → "YYYY-MM-DD". */
export const localDateToYmd = (date: Date): string => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

/** Current local time as "HH:mm" (the default clock-in start). */
export const currentTimeHHmm = (date: Date = new Date()): string => {
  const hh = String(date.getHours()).padStart(2, '0');
  const mm = String(date.getMinutes()).padStart(2, '0');
  return `${hh}:${mm}`;
};

/** Inclusive ±1 calendar day around `anchor` (defaults to local now). Day-granularity only. */
export const kioskDateBounds = (anchor: Date = new Date()): { minDate: Date; maxDate: Date } => {
  const minDate = new Date(anchor);
  minDate.setDate(minDate.getDate() - 1);
  const maxDate = new Date(anchor);
  maxDate.setDate(maxDate.getDate() + 1);
  return { minDate, maxDate };
};
